import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'

import ImageVersioningContext from '../../../context/ImageVersioningContext'

/**
 * Image component that handles image versioning and error handling.
 *
 * @param {*} param
 * @param {String} param.alt - Alt text for the image
 * @param {String} param.className - CSS class for the image
 * @param {String} param.url - URL of the image
 * @param {Function} param.onError - Callback for image load error
 * @param {Boolean} param.noCache - Whether to bypass cache
 * @returns {JSX.Element|null}
 */
const Image = ({ alt, className, url, onError, noCache = false }) => {
  const { getUrlWithVersion } = useContext(ImageVersioningContext)
  const [imageExists, setImageExists] = useState(url?.length > 0)

  useEffect(() => {
    setImageExists(url?.length > 0)
  }, [url])

  const handleError = () => {
    setImageExists(false)
    if (onError) {
      onError()
    }
  }

  if (!imageExists) return null

  const src = getUrlWithVersion(url)
  // Add a unique timestamp to force bypassing the cache
  const noCacheSrc = `${src}${src.includes('?') ? '&' : '?'}t=${Date.now()}`

  return <img alt={alt} className={className} onError={handleError} src={noCache ? noCacheSrc : src} />
}

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
  onError: PropTypes.func,
  noCache: PropTypes.bool,
}

export default Image
